var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.006 480.006",
    style: {
      enableBackground: "new 0 0 480.006 480.006"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.192,162.883l31.256-29.016c3.239-3.005,3.428-8.067,0.422-11.306c-1.515-1.633-3.643-2.56-5.87-2.558h-6.864     L479.928,9.059c0.583-4.38-2.494-8.403-6.874-8.986c-0.349-0.047-0.701-0.07-1.054-0.07h-32c-2.674,0-5.172,1.335-6.656,3.56     l-77.624,116.44H269.6L303,59.891c1.376-2.479,1.336-5.502-0.104-7.944c-1.437-2.444-4.061-3.944-6.896-3.944h-32     c-1.731,0-3.415,0.561-4.8,1.6l-93.864,70.4h-57.44c-48.783-0.044-92.103,31.179-107.488,77.472     c-0.271,0.815-0.409,1.669-0.408,2.528c0,13.255,10.745,24,24,24h165.6l69.984,46.656c1.309,0.87,2.844,1.337,4.416,1.344h32     c4.418-0.001,7.999-3.584,7.998-8.002c-0.001-1.976-0.732-3.881-2.054-5.35l-31.48-34.984     c42.644-1.616,84.456-12.281,122.664-31.288l18.824-9.408l56.896,24.384c4.065,1.731,8.764-0.162,10.494-4.227     c1.277-2.999,0.606-6.472-1.694-8.781L446.192,162.883z M444.28,16.003h18.584l-13.864,104h-74.056L444.28,16.003z      M266.664,64.003H282.4l-31.104,56H192L266.664,64.003z M356.848,159.355l35.84,15.36l-6.712,3.352     c-39.38,19.633-82.773,29.88-126.776,29.936h-2.824l-10.984-12.2l-15.432-17.152l-11.888,10.704l7.2,8l16.328,18.168l36.44,40.48     H266.4l-69.984-46.656l-48-32l-8.88,13.312l26.064,17.344H24c-3.99-0.002-7.369-2.944-7.92-6.896     c4.286-12.239,10.98-23.495,19.688-33.104H88v-16H54.512c15.849-10.434,34.408-15.997,53.384-16h343.736l-16.76,15.56     l-5.216-5.216c-1.5-1.5-3.534-2.344-5.656-2.344h-64c-4.418,0.001-7.999,3.584-7.998,8.002     C352.003,155.204,353.909,158.094,356.848,159.355z M398.976,160.003h21.712l16.28,16.28L398.976,160.003z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 152.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 152.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 152.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 152.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 152.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,288.003c-53.019,0-96,42.981-96,96s42.981,96,96,96s96-42.981,96-96C335.943,331.008,292.996,288.06,240,288.003z      M201.416,313.971c-4.94,8.165-8.763,16.955-11.368,26.136c-6.75,1.209-13.406,2.891-19.92,5.032     C177.451,332.039,188.288,321.244,201.416,313.971z M160,384.003c0.012-5.923,0.686-11.826,2.008-17.6     c7.508-4.321,15.663-7.406,24.152-9.136c-1.438,8.839-2.161,17.78-2.16,26.736c0.004,6.147,0.343,12.29,1.016,18.4     c-8.709-1.798-17.025-5.145-24.552-9.88C160.159,389.693,160.004,386.849,160,384.003z M165.616,413.186     c7.215,2.758,14.66,4.871,22.248,6.313c2.586,12.187,7.165,23.864,13.552,34.56C185.098,445.005,172.441,430.554,165.616,413.186     z M232,462.299c-11.496-4.888-21.352-20-26.984-40.192c9.624,1.096,18.912,1.608,26.984,1.792V462.299z M232,407.835     c-10.169-0.193-20.318-0.963-30.4-2.304c-1.05-7.128-1.585-14.323-1.6-21.528c-0.011-9.999,0.997-19.973,3.008-29.768     c9.621-1.202,19.298-1.893,28.992-2.072V407.835z M232,336.091c-7.272,0.168-15.6,0.584-24.288,1.48     c5.808-15.968,14.432-27.696,24.288-31.88V336.091z M248,305.691c9.856,4.184,18.48,15.944,24.288,31.896     c-8.688-0.896-17.016-1.312-24.288-1.48V305.691z M248,462.315v-0.016v-38.4c8.072-0.184,17.36-0.68,26.984-1.776     C269.352,442.291,259.496,457.427,248,462.315z M248,407.835v-0.016v-55.656c9.694,0.179,19.371,0.87,28.992,2.072     c2.011,9.795,3.019,19.769,3.008,29.768c-0.015,7.205-0.55,14.4-1.6,21.528C268.318,406.872,258.169,407.642,248,407.835z      M278.604,454.023c6.376-10.687,10.948-22.351,13.532-34.524c7.602-1.445,15.061-3.562,22.288-6.328     C307.59,430.535,294.925,444.978,278.604,454.023z M320,384.003c-0.005,2.836-0.16,5.669-0.464,8.488     c-7.525,4.746-15.841,8.104-24.552,9.912c0.673-6.11,1.012-12.253,1.016-18.4c-0.001-8.948-0.723-17.881-2.16-26.712v-0.016     c8.488,1.727,16.643,4.809,24.152,9.128C319.314,372.177,319.988,378.08,320,384.003z M289.952,340.107     c-2.605-9.181-6.428-17.971-11.368-26.136c13.128,7.273,23.965,18.068,31.288,31.168     C303.358,342.998,296.702,341.316,289.952,340.107z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,304.003h-68c-11.046,0-20-8.954-20-20c0-11.046,8.954-20,20-20h56c19.873-0.022,35.978-16.127,36-36v-12h-16v12     c0,11.046-8.954,20-20,20h-56c-19.882,0-36,16.118-36,36s16.118,36,36,36h68c13.255,0,24,10.745,24,24s-10.745,24-24,24h-16v16     h16c22.091,0,40-17.909,40-40C472,321.912,454.091,304.003,432,304.003z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 368.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 368.003,
    width: 16,
    height: 16,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0988ddb9aff7f76a62d300059971d36a.svg";
export { ForwardRef as ReactComponent };